import {map} from 'rxjs/operators';
import {GetCurrentDeliveryPointUseCase} from '@app/core/delivery-point/application/get-current-delivery-point.use-case';
import {Injectable} from "@angular/core";
import {UserLocal} from "@app/core/user/domain/user.local";
import {combineLatest, Observable} from "rxjs";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";

/**
 * Use case to check if the user is logged in.
 */
@Injectable({
    providedIn: 'root'
})
export class IsLoggedInUseCase {
    constructor(
        private userLocal: UserLocal,
        private getCurrentDeliveryPointUseCase: GetCurrentDeliveryPointUseCase,
        private credentialsStorage: CredentialsStorage,
        ) { }

    execute(): Observable<boolean> {
        return combineLatest([this.userLocal.isLoggedIn$,this.getCurrentDeliveryPointUseCase.execute()]).pipe(
            map(([isLoggedIn, currentDeliveryPoint])=>
                isLoggedIn && (currentDeliveryPoint != null) && (this.credentialsStorage.getCredentials() != null)
            )
        )
    }
}
